import type { InferGetServerSidePropsType } from 'next';
import { CollectionsRoute } from 'components/route/collections/CollectionsRoute';
import { collectionsSSRProps } from 'components/route/collections/collectionsSSRProps';

/**
 * Product List Page Route
 *
 * @param props - handle: string;
 */
export default function PLPRoute(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  return <CollectionsRoute props={props} />;
}

export const getServerSideProps = collectionsSSRProps;
